//Please add the language resource
const emailReceiveOrderDelay = {
  updateTime:'UpdateTime',
  lastTaxRate:'LastTaxRate',
  contact:'Contact',
  carrierNo:'CarrierNo',
  carrierName:'CarrierName',
  email:'Email',
  updater:'Updater',
  msg:{
    carrierNo:'Please input the CarrierNo',
    carrierName:'Please input the CarrierName',
  }
};
export default emailReceiveOrderDelay



// WEBPACK FOOTER //
// ./src/page/md/emailReceiveOrderDelay/lang/emailReceiveOrderDelay.en.js